module.exports = __webpack_public_path__ + "img/product1.f116d268.png";